// 财务核算API接口
import request from './request';

/**
 * 交付人核算API（新）
 * 用于明细核算记录，支持独立结算
 */
export const agentAccountingApi = {
  // 获取核算明细列表
  getRecords: (params) => request.get('/agent-accounting/records', { params }),
  
  // 获取统计数据
  getStats: (params) => request.get('/agent-accounting/stats', { params }),
  
  // 批量更新单价
  updateUnitPrices: (updates) => request.post('/agent-accounting/unit-prices', { updates }),
  
  // 手动同步订单
  syncOrder: (orderId) => request.post(`/agent-accounting/sync/${orderId}`),
  
  // 一键同步所有历史订单
  syncAll: () => request.post('/agent-accounting/sync-all'),
  
  // 导出核算明细
  exportRecords: (data) => request.post('/agent-accounting/export', data),

  // 创建结算批次（与甲方结算）
  createSettlementBatch: (data) => request.post('/agent-accounting/settlement-batches', data),

  // 获取结算批次列表
  getSettlementBatches: (params) => request.get('/agent-accounting/settlement-batches', { params }),

  // 获取批次详情
  getSettlementBatchDetail: (id) => request.get(`/agent-accounting/settlement-batches/${id}`),

  // 导出甲方结算 CSV
  exportPartyASettlement: (data) => request.post('/agent-accounting/export-party-a-settlement', data, {
    responseType: 'blob'
  }),

  // 按来源获取待结账记录
  getPendingRecords: (params) => request.get('/agent-accounting/pending-records', { params }),

  // 按来源直接导出待结账记录 CSV（甲方结算表）
  exportPending: (data) => request.post('/agent-accounting/export-pending', data, {
    responseType: 'blob'
  }),

  // 导出甲方对账表 CSV（按订单聚合，来源可选，不传则全部甲方）
  exportPartyAChecklist: (data) => request.post('/agent-accounting/export-party-a-checklist', data, {
    responseType: 'blob'
  }),

  // 按来源导出代投员结算明细合并版
  exportPendingDetail: (data) => request.post('/agent-accounting/export-pending-detail', data, {
    responseType: 'blob'
  }),

  // 获取已归档批次列表
  getArchivedBatches: (params) => request.get('/agent-accounting/archived-batches', { params }),

  // 撤销结算
  reverseBatchSettled: (id) => request.post(`/agent-accounting/settlement-batches/${id}/reverse-settled`),

  // 归档批次
  archiveSettlementBatch: (id) => request.post(`/agent-accounting/settlement-batches/${id}/archive`),

  // 一键批量定价
  batchPrice: (data) => request.post('/agent-accounting/batch-price', data),

  // 更新单条核算记录的企业类型统计
  updateRecordCompanyType: (id, data) => 
    request.put(`/agent-accounting/records/${id}/company-type`, data),

  // 更新单条记录的核实状态
  updateRecordVerificationStatus: (id, data) => 
    request.put(`/agent-accounting/records/${id}/verification-status`, data)
};

// ============== 核算工作台接口 ==============
export const workbenchApi = {
  // 获取核算订单列表
  getOrders: (params) => request.get('/accounting/workbench/orders', { params }),
  
  // 修改代投员投递数
  updateAgentCount: (orderId, agentId, data) => 
    request.put(`/accounting/workbench/orders/${orderId}/agents/${agentId}`, data),
  
  // 标记订单已核实
  verifyOrder: (orderId, data) => 
    request.post(`/accounting/workbench/orders/${orderId}/verify`, data),
  
  // 批量标记已核实
  batchVerify: (data) => 
    request.post('/accounting/workbench/orders/batch-verify', data),
  
  // 取消核实
  unverifyOrder: (orderId, data) => 
    request.post(`/accounting/workbench/orders/${orderId}/unverify`, data),
  
  // 导出结算表
  exportSettlement: (data) => 
    request.post('/accounting/workbench/export', data, { responseType: 'blob' })
};

// ============== 核算期管理接口 ==============
export const accountingPeriodApi = {
  // 获取当前核算期状态
  getCurrent: () => request.get('/accounting-periods/current'),
  
  // 开启核算期（管理员）
  open: (data) => request.post('/accounting-periods/open', data),
  
  // 关闭核算期（管理员）
  close: () => request.post('/accounting-periods/close')
};

export const accountingApi = {
  // 获取对账统计
  getStats: (params) => request.get('/accounting/stats', { params }),
  
  // 老板视图
  getBossView: (params) => request.get('/accounting/boss-view', { params }),
  
  // 学生月度台账
  getStudentLedger: (params) => request.get('/accounting/student-ledger', { params }),
  
  // 投递员结账表
  getAgentSettlement: (params) => request.get('/accounting/agent-settlement', { params }),
  
  // 月度状态表
  getMonthlyStatus: (params) => request.get('/accounting/monthly-status', { params }),
  
  // 确认对账
  confirmAccounting: (data) => request.post('/accounting/confirm', data),
  
  // 标记已结算
  markSettled: (data) => request.post('/accounting/mark-settled', data),
  
  // 反结账
  reverseAccounting: (data) => request.post('/accounting/reverse', data),
  
  // 导出数据
  exportData: (data) => request.post('/accounting/export', data),
  
  // ============== 组长核算相关接口 ==============
  
  // 组长结账表
  getLeaderSettlement: (params) => request.get('/accounting/leader-settlement', { params }),
  
  // 组长老板视图
  getLeaderBossView: (params) => request.get('/accounting/leader-boss-view', { params })
};
